import React from 'react';

const LinkifyText = ({ text }) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    // Divide el texto en fragmentos, transformando URLs en enlaces
    const parts = text.split(urlRegex).map((part, index) => {
        if (part.match(urlRegex)) {
            return (
                <a key={index} href={part} target="_blank" rel="noopener noreferrer">
                    {part}
                </a>
            );
        }
        return part;
    });

    return <p>{parts}</p>;
};

export default LinkifyText;